import { useMemo } from "react";
import {
  CellClassParams,
  CheckboxEditorModule,
  ColDef,
  ColGroupDef,
  ModuleRegistry
} from "ag-grid-enterprise";
import {
  coldefDateField,
  coldefSingleField
} from "entity-app/shared-components/log-render-components/col-defs";
import { CellValueRendererWithEditIcon } from "components/cell-renders";
import { comparatorWithEmptyAtBottom } from "utils/grid-utils";
import { MaterialExtractSpecType } from "../model";
import activeInlogCellRenderer from "../components/checkbox/active-inlog-cell-renderer";

ModuleRegistry.registerModules([CheckboxEditorModule]);

export const useMaterialLogAgGrid = (props: {
  pageData: {
    materialHeaderMap: any;
  };
}) => {
  const { materialHeaderMap } = props.pageData;

  const isGridCellEditable = (
    params: CellClassParams<any, any>
  ): boolean | undefined => {
    return !!params?.colDef?.editable;
  };

  const defaultColDef = useMemo(
    () =>
      ({
        sortable: true,
        editable: false,
        filter: true,
        resizable: true,
        minWidth: 100,
        cellRenderer: CellValueRendererWithEditIcon,
        cellEditorPopup: false,
        comparator: comparatorWithEmptyAtBottom
      }) as ColDef<MaterialExtractSpecType>,
    []
  );

  const columnDefs = useMemo(
    () =>
      [
        coldefSingleField({
          field: "table_title",
          headerName: "Schedule Name",
          width: 260
        }),
        coldefSingleField({
          field: "title",
          headerName: materialHeaderMap?.name || "Material Name",
          width: 320
        }),
        coldefSingleField({
          field: "tag",
          headerName: materialHeaderMap?.tag_name || "Tag",
          width: 160
        }),
        coldefSingleField({
          field: "manufacturer",
          headerName: materialHeaderMap?.manufacturer || "Manufacturer",
          width: 240
        }),
        coldefSingleField({
          field: "location",
          headerName: materialHeaderMap?.locations || "Location",
          width: 230,
          valueGetter: ({ data }: any) => {
            return data.location || data.LOCATION || "";
          }
        }),
        coldefSingleField({
          field: "spec_page_extract.spec_page.specification.title",
          headerName: materialHeaderMap?.source || "Source",
          width: 240
        }),
        coldefDateField({
          field: "spec_page_extract.created_at",
          headerName: "Extracted On",
          width: 160,
          filterParams: {
            isCustomFilterOnly: true
          }
        }),
        coldefSingleField({
          field: "active",
          headerName: "Action",
          width: 120,
          pinned: "right",
          lockPosition: "right",
          cellRenderer: activeInlogCellRenderer,
          valueGetter: ({ data }: any) => {
            return data.grouped_parent?.length ? "Tracked" : "Blank";
          }
        })
      ] as (
        | ColDef<MaterialExtractSpecType>
        | ColGroupDef<MaterialExtractSpecType>
      )[],
    [
      materialHeaderMap?.locations,
      materialHeaderMap?.manufacturer,
      materialHeaderMap?.name,
      materialHeaderMap?.source,
      materialHeaderMap?.tag_name
    ]
  );
  return {
    columnDefs,
    defaultColDef,
    isGridCellEditable
  };
};
